import { render, staticRenderFns } from "./CheckPasswortSicherheit.vue?vue&type=template&id=56a1ea5c"
import script from "./CheckPasswortSicherheit.vue?vue&type=script&lang=js"
export * from "./CheckPasswortSicherheit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports